import { createSlice } from '@reduxjs/toolkit'; 
import { IAmericanState } from '../../types';
import { fetchAmericanStatesAsync, fetchAmericanStatesAsyncBuilder } from './asyncRequests';

export interface IData{
  states: IAmericanState[]
  selectedState: IAmericanState
}

export interface AmericanStatesInitialState {
  data: IData
  loading: boolean
  error: string
  success: boolean
}

const initialState: AmericanStatesInitialState = {
  data: { states: [] as IAmericanState[] , selectedState: {} as IAmericanState},
  loading: false,
  error: '',
  success: false,
}

export const AmericanStatesSlice = createSlice({
  name: 'americanStatesSlice',
  initialState,
  reducers: {
    setSelectedState:(state,action)=> {
      state.data.selectedState = action.payload
    },
    setSelectedStateFromAbbr: (state,action) => {
      const stateAbbr = action.payload

      const stateFound = state.data.states.find(
        (state: any) => state.state_abbr === stateAbbr
      )

      if(stateFound){
        state.data.selectedState = stateFound
      }
    }
  },
  extraReducers: (builder) => {
    fetchAmericanStatesAsyncBuilder(builder);
  },
})

export const AmericanStatesActions = {
  ...AmericanStatesSlice.actions,
  fetchAmericanStatesAsync,
}

export const AmericanStatesReducer = AmericanStatesSlice.reducer;
